
import { useCallback } from "react";
import { Movie } from "@/types/movie";
import { toast } from "@/hooks/use-toast";

/**
 * Hook for basic movie management operations (add, update)
 */
export const useMovieManagement = (
  addMovie: (movie: Movie) => void,
  updateMovie: (movie: Movie) => void
) => {
  // Wrap addMovie with error handling
  const handleAddMovie = useCallback(async (movie: Movie) => {
    try {
      addMovie(movie);
    } catch (error) {
      console.error("Error adding movie:", error);
      toast({
        title: "Error",
        description: "Failed to add movie",
        variant: "destructive"
      });
    }
  }, [addMovie]);

  // Wrap updateMovie with error handling
  const handleUpdateMovie = useCallback(async (movie: Movie) => {
    try {
      updateMovie(movie);
    } catch (error) {
      console.error("Error updating movie:", error);
      toast({
        title: "Error",
        description: "Failed to update movie",
        variant: "destructive"
      });
    }
  }, [updateMovie]);

  return {
    addMovie: handleAddMovie,
    updateMovie: handleUpdateMovie
  };
};
